export default __webpack_public_path__ + "static/9 - Hibafeltárás-50edf849cc58eda23928d90ba12b5902.jpg";